import { render, staticRenderFns } from "./VoiceMessageRecorder.vue?vue&type=template&id=64f1091e&scoped=true"
import script from "./VoiceMessageRecorder.vue?vue&type=script&lang=js"
export * from "./VoiceMessageRecorder.vue?vue&type=script&lang=js"
import style0 from "./VoiceMessageRecorder.vue?vue&type=style&index=0&id=64f1091e&prod&scoped=true&lang=css"
import style1 from "./VoiceMessageRecorder.vue?vue&type=style&index=1&id=64f1091e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1091e",
  null
  
)

export default component.exports